import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'

import InfoBar from './student-grades-info-bar'
import StudentGradesFilters from './student-grades-filters'
import StudentGradesSummary from './student-grades-summary'
import StudentAnsweredAssessments from './student-answered-assessments'

const useStyles = makeStyles(gradesStyles)

export default function StudentGrades({context}) {

  const classes = useStyles()  

  return (
    <Box className={classes.root} > 
      <Box className={classes.infoBar}>
        <InfoBar />
      </Box>
      <Box className={classes.content}>
        <StudentGradesFilters />
        <StudentGradesSummary />
        <StudentAnsweredAssessments />
      </Box>
    </Box>
  )
}

function gradesStyles(theme) {
 return {
    root: {
      flexGrow: 1,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      borderRadius: '4px',
      boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
    },
    content: {
      padding: '25px 20px',
      overflowY: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    }
  }
}

